// src/context/TeklifContext.js
import React, { createContext, useState } from 'react';

export const TeklifContext = createContext();

export const TeklifProvider = ({ children }) => {
  const [teklifParcalari, setTeklifParcalari] = useState([]);

  const parcayiTeklifeEkle = (parca) => {
    setTeklifParcalari((prev) => [...prev, parca]);
  };

  const temizleTeklif = () => {
    setTeklifParcalari([]);
  };

  return (
    <TeklifContext.Provider value={{ teklifParcalari, parcayiTeklifeEkle, temizleTeklif }}>
      {children}
    </TeklifContext.Provider>
  );
};
